module.exports = __webpack_public_path__ + "static/media/tiled-red-card.70e75310.png";